import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  mixed,
} from 'libs/form';
import { Maybe } from 'types/maybe';
import { YesOrNoSelectType, YesOrNoType } from 'types/yesOrNo';

export interface OnboardingSettingsFormType {
  isAutomaticPersonalAccountGenerationEnabled: Maybe<YesOrNoSelectType>;
}

export const getSchema = (): ObjectSchema<OnboardingSettingsFormType> =>
  object({
    isAutomaticPersonalAccountGenerationEnabled: object({
      value: mixed<YesOrNoType>().oneOf(Object.values(YesOrNoType)).required(),
      label: string().required(),
    })
      .default(null)
      .required(),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<OnboardingSettingsFormType>();

export type FormErrors = FormErrorsBase<OnboardingSettingsFormType>;
